/**
 * 账户内转，仅 IRA 账户有该种入金方式
 * 从综合账户向 IRA 账户转账
 */
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasIRAAccountAndLiveAccount } from 'stores/helper';

const Transfer: FC = () => {
    if (!hasIRAAccountAndLiveAccount()) {
        return <Navigate to="/deposit" replace />;
    }

    return (
        <div className="deposit-transfer-root">
            <Outlet />
        </div>
    );
};

export default Transfer;
